import React from "react";
import PropTypes from "prop-types";
import { ContainerTexts, OptionCardContainer, OptionIcon, OptionText, Title } from "./styles";

const OptionCard = ({ title, description, icon, onClick }) => {
  return (
    <OptionCardContainer onClick={onClick}>
      <ContainerTexts>
        <Title>{title}</Title>
        <OptionText>{description}</OptionText>
      </ContainerTexts>
      <OptionIcon>{icon}</OptionIcon>
    </OptionCardContainer>
  );
};

OptionCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default OptionCard;
